import cn from "@utils/cn";
import ContentLoaderContainer from "@elements/ContentLoaderContainer";

export default function FormFieldLoader(props) {
  const {
    className,
  } = props;

  return (
    <div className={cn("flex flex-col gap-2", className)}>
      <ContentLoaderContainer height="18" />
      <ContentLoaderContainer height="42" />
    </div>
  );
}
